import React from 'react';
import { Alert } from 'antd';

// ECI old sends everything itself; there is nothing to upload here any more
export const FeedSection = () => (
  <Alert
    type='info'
    showIcon
    message='Квартиры загружать не нужно'
    description='Все квартиры приходят со старого сайта ЕЦИ: изменения сразу после сохранения, статусы и цены каждый час, ночью полная сверка. ЖК, очереди, корпуса и секции шахматки выстраиваются по ним сами. Ручная загрузка фидов ЕЦИ и 3bita отключена.'
  />
);
